

export default function Footer(){
    return (
        <div className="attribution">
            Challenge by <a href="https://www.frontendmentor.io?ref=challenge">Frontend Mentor</a>. 
            Coded by <a href="https://github.com/MorganBare">Morgan J. Bare</a>.
        </div>
    )
}